module.exports = __webpack_public_path__ + "img/icon-double-reward.28ec4fc3.svg";